import { MerchantGuidedRecommendationOutputSchema } from "@redotech/redo-agents-common/returns-agents/exchange-agent/merchant-guided-recommendation";
import { ReturnReasonSchema } from "@redotech/redo-agents-common/returns-agents/exchange-agent/return-reasons";
import { ReturnProductSchema } from "@redotech/redo-return-core-common/draft-return/draft-return-items";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getMerchantGuidedRecommendations = unaryRpc({
  name: "getMerchantGuidedRecommendations" as const,
  input: z.object({
    draftReturnId: z.string(),
    returnProduct: ReturnProductSchema,
    returnReasons: z.array(ReturnReasonSchema),
    locale: z.string().optional(),
  }),
  output: MerchantGuidedRecommendationOutputSchema,
});
